module.exports = __webpack_public_path__ + "media/images/user/lp/recommend/male-c73dcb95fd6288377591107cf236e7c6.png";